import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import MatchCard from "../components/MatchCard"
import { getMatches } from "../services/matchService"
import BottomNav from "../components/BottomNav"
import API from "../services/api"
import { getUser } from '../utils/storage'
import { useRef } from 'react'
import { useTheme } from "../context/ThemeContext"
import BannerSlider from "../components/BannerSlider"


const Home = () => {
  const navigate = useNavigate()
  const [matches, setMatches] = useState([])
  const [balance, setBalance] = useState("0")
  const { isDarkMode, toggleTheme } = useTheme()
  const hasFetched = useRef(false)

  const storedUser = getUser()

  useEffect(() => {
    if (hasFetched.current) return
    hasFetched.current = true
    console.log("🏠 Home Component Mounted")
    fetchMatches()
    fetchBalance()

    // 🔄 Auto-refresh matches every 30 seconds
    const interval = setInterval(() => {
      console.log("🔄 Background refreshing matches...")
      fetchMatches()
    }, 30000)

    return () => clearInterval(interval)
  }, [])

  const fetchBalance = async () => {
    try {
      const res = await API.get(`/wallet/balance?userId=${storedUser.id || 1}`)
      setBalance(res.data.balance)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchMatches = async () => {
    try {
      console.log("Fetching matches from backend...")
      const res = await getMatches(1, '', 60);
      const allData = res.data || [];
      const formatted = allData.map(m => ({ ...m, id: m.match_id || m.id }))

      console.log("✅ API DATA LOADED:", formatted.length, "matches")
      setMatches(formatted)
    } catch (err) {
      console.error("Error fetching matches:", err)
    }
  }

  // 🔥 filter
  const liveMatches = (matches || [])
    .filter(m => m && m?.status?.toLowerCase() === "live")
    .slice(0, 2)

  const upcomingMatches = (matches || [])
    .filter(m => m && m?.status?.toLowerCase() === "upcoming")
    .slice(0, 6)

  // ✅ OPTIONAL (future use)
  const completedMatches = matches
    .filter(m => m && m.status?.toLowerCase() === "completed")

  return (
    <div className="bg-theme-bg text-theme-text min-h-screen pb-16">

      {/* 🔝 TOP BAR (Branded) */}
      <div className="flex items-center justify-between p-4 glass-card sticky top-0 z-[60] transition-all border-b border-theme-border/50">
        {/* LOGO (Static as requested) */}
        <div className="flex items-center space-x-2">
          <img src="/cricket_logo.png" alt="WinroX11" className="w-9 h-9 rounded-lg object-contain" />
        </div>

        {/* BRAND NAME */}
        <h1 className="text-xl font-black text-theme-text tracking-widest uppercase italic">Winro<span className="text-accent">X11</span></h1>

        <div className="flex items-center space-x-2">
          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            className="w-10 h-10 flex items-center justify-center bg-gray-500/10 rounded-xl border border-gray-500/20 text-theme-text active:scale-90 transition-all shadow-sm"
            aria-label="Toggle Theme"
          >
            {isDarkMode ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            )}
          </button>

          {/* WALLET ICON */}
          <button
            onClick={() => navigate("/wallet")}
            className="w-10 h-10 flex items-center justify-center bg-green-500/10 rounded-xl border border-green-500/20 text-green-500 active:scale-90 transition-all shadow-sm"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 7H5C3.89543 7 3 7.89543 3 9V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16 11V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M7 7V5C7 4.46957 7.21071 3.96086 7.58579 3.58579C7.96086 3.21071 8.46957 3 9 3H15C15.5304 3 16.0391 3.21071 16.4142 3.58579C16.7893 3.96086 17 4.46957 17 5V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>

      <div className="px-3 py-4">

        {/* 📢 AD BANNERS */}
        <BannerSlider />

        {/* 🔥 NEW PROMO BANNER (Minimal Redesign) */}
        <div
          onClick={() => navigate("/player-performance")}
          className="relative w-full rounded-theme p-5 mb-6 cursor-pointer overflow-hidden group shadow-theme-md border border-theme-border glass-card hover-glow"
        >
          <div className="relative z-10 flex items-center justify-between">
            <div className="flex-1">
              <span className="bg-accent/10 text-accent text-[8px] font-bold px-2 py-0.5 rounded-full mb-1 inline-block uppercase tracking-wider border border-accent/20">New</span>
              <h3 className="text-theme-text font-bold text-lg leading-tight mt-0.5 tracking-tight">Predict Player Stats<br />& Win Cash! 💰</h3>
              <p className="text-theme-text-sec text-[10px] mt-1 font-medium italic">Predict & win BIG on every match</p>
            </div>
            <div className="w-16 h-16 flex items-center justify-center relative">
              <img src="/leagues_promo_icon.png" alt="Leagues" className="w-16 h-16 object-contain drop-shadow-theme-sm" />
            </div>
          </div>
        </div>

        {/* 🔴 LIVE MATCHES */}
        {liveMatches.length > 0 && (
          <>
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-red-500 font-semibold">Live Matches</h2>
              <button
                onClick={() => navigate("/leagues")}
                className="text-sm text-theme-text-sec"
              >
                View All
              </button>
            </div>
            <div className="grid grid-cols-2 gap-3 animate-fade-in">
              {liveMatches.map(match => (
                <MatchCard key={match.id} match={match} />
              ))}
            </div>
          </>
        )}

        {/* 🟢 UPCOMING MATCHES */}
        <div className="flex justify-between items-center mt-6 mb-2">
          <h2 className="font-semibold text-theme-text-sec">Upcoming Matches</h2>
          <button
            onClick={() => navigate("/leagues")}
            className="text-sm text-theme-text-sec"
          >
            View All
          </button>
        </div>

        {upcomingMatches.length === 0 ? (
          <p className="text-theme-text-sec text-sm">No upcoming matches</p>
        ) : (
          <div className="grid grid-cols-2 gap-3 animate-fade-in">
            {(upcomingMatches || []).slice(0, 10).map(match => (
              <MatchCard key={match?.id || match?.match_id} match={match} />
            ))}
          </div>
        )}

      </div>

      {/* 🔻 BOTTOM NAVBAR */}
      <BottomNav activeTab="home" />
    </div>
  )
}

export default Home